import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import Moment from "react-moment";

import JobPostApply from "./JobPostApply";

let formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const JobPostItem = ({
  auth: { user, isAuthenticated },
  jobpostitem,
  setShowAddAttachment,
}) => {
  const [showJob, setShowJob] = useState(false);
  return (
    <Fragment>
      <div className="post-container-section-dark">
        <div
          className="post-section-info-container"
          onClick={() => setShowJob(true)}
        >
          <div className="flex-start">
            <ul className="info-items">
              <li className="info-item">{jobpostitem.jobtitle}</li>
              <li className="info-item">{jobpostitem.employmenttype}</li>
              {jobpostitem.salary > 0 && (
                <li className="info-item">
                  {formatter.format(jobpostitem.salary)}
                </li>
              )}
              <li className="info-item">
                {jobpostitem.location.city}, {jobpostitem.location.state}
              </li>
              <li className="info-item">
                <i className="far fa-clock mr-5 blue"></i>
                <Moment format="MM/DD/YYYY">{jobpostitem.date}</Moment>
              </li>
            </ul>
          </div>
          <div className="flex-end">
            <div className="avi-color-border blue">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${jobpostitem.avatar}`}
                className="avatar"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="posts-buttons-container">
        <button
          type="submit"
          className="post-button background-dark-black white"
          onClick={() => setShowJob(true)}
        >
          <i className="far fa-file-alt blue mx-5"></i>View Job Post
        </button>
        {user && user.role === "employer" && (
          <button type="submit" className="post-button background-blue">
            <i className="fas fa-edit mx-5"></i>Edit
          </button>
        )}
        {user && user.role === "employer" && (
          <button type="submit" className="post-button background-red">
            <i className="fas fa-times mx-5"></i>Delete
          </button>
        )}
      </div>
      {showJob && (
        <JobPostApply
          isAuthenticated={isAuthenticated}
          setShowJob={setShowJob}
          jobpostitem={jobpostitem}
          setShowAddAttachment={setShowAddAttachment}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(JobPostItem);
